import {Button, Tag} from '@/components-v2'

export const OrderChangeTag = ({originalPosition, position, onUndo, disabled}) => {
  if (!originalPosition || originalPosition === position) return null

  return (
    <div
      className="flex shrink-0 items-center gap-1"
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
    >
      <Tag
        text={
          <div className="flex items-center gap-2">
            <p>{`Changed: ${originalPosition} \u2192 ${position}`}</p>
            <Button
              type="button"
              text="Undo"
              variant="tertiary"
              size="small"
              disabled={disabled}
              onClick={onUndo}
            />
          </div>
        }
        type="outlined"
      />
    </div>
  )
}
